(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7394],{

/***/ 77394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content024": function() { return /* binding */ Content024; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32667);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88494);
/* harmony import */ var _Content024_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61753);
/* harmony import */ var _Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var Content024 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var points = (ref2 = payload === null || payload === void 0 ? void 0 : payload.points) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    var slider = (ref3 = payload === null || payload === void 0 ? void 0 : payload.slider) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    var ref5 = (ref4 = payload === null || payload === void 0 ? void 0 : payload.attachment) !== null && ref4 !== void 0 ? ref4 : {}, attachmentButtonText = ref5.attachmentButtonText, file = ref5.file;
    var isDesktop = (0,shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_5__/* .useViewMode */ .mJ)().isDesktop;
    var prevRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var nextRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
            className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inner),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().slider),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .SwiperLayout */ .OJ, {
                            prevRef: prevRef,
                            nextRef: nextRef,
                            watchOverflow: false,
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            loop: true,
                            paginationWrapper: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pagination),
                            children: slider.map(function(slide) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                    className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().slide),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .ImageLite */ .NH, {
                                        image: slide,
                                        className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().image)
                                    })
                                }, slide.id);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["navigation-wrapper"]),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["slider-navigation"]),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            ref: prevRef,
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().navigation), (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["navigation-prev"])),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                                className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().icon),
                                                name: "arrow_slider_prev"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            ref: nextRef,
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().navigation), (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["navigation-next"])),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                                className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().icon),
                                                name: "arrow_slider_next"
                                            })
                                        })
                                    ]
                                }),
                                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pagination)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().blocks),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().left),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Heading3 */ .aC, {
                                    as: "h3",
                                    className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                                    color: "light",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                    value: description,
                                    className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().description),
                                    color: "light"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .DownloadFile */ .xn, {
                                    file: file,
                                    label: attachmentButtonText,
                                    color: "light"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().right),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .AccordionList */ .ES, {
                                items: points,
                                className: (_Content024_module_scss__WEBPACK_IMPORTED_MODULE_7___default().list),
                                appearance: "bold",
                                color: "light"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content024);


/***/ }),

/***/ 61753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content024_wrapper__5JLkK","blocks":"Content024_blocks__SXhfW","left":"Content024_left__U8jMQ","right":"Content024_right__aX_r4","list":"Content024_list__NVOzZ","title":"Content024_title__cxOsw","description":"Content024_description__rrEJR","image":"Content024_image__gopAy","slider":"Content024_slider__5hmT1","slide":"Content024_slide__l0fEh","navigation-wrapper":"Content024_navigation-wrapper__G1OLg","pagination":"Content024_pagination__IfFTi","pagination-current":"Content024_pagination-current__eD9Nc","slider-navigation":"Content024_slider-navigation__3rcFd","navigation":"Content024_navigation__E01Kf","navigation-prev":"Content024_navigation-prev__gNl7_","navigation-next":"Content024_navigation-next__veyyY"};

/***/ })

}]);